import React, { Component } from 'react'
import { ToastContainer, toast } from 'react-toastify';

import close from '../images/close.png'
import facebook from '../images/facebook-square-brands.svg'
import instagram from '../images/instagram-square-brands.svg'
import whaatsapp from '../images/whatsapp-square-brands.svg'
import twitter from '../images/twitter-square-brands.svg'
import copy from '../images/copy-solid.svg'

export class ShareModal extends Component {
    constructor(props){
        super();
        this.state={
            textToCopy: ""
        }
    }

    copyToClipboard = (e) => {
        this.textArea.select();
        document.execCommand('copy');
        
        toast.dark("Copied to clipboard")
        this.props.toggleShare()
    };

    setCopyText = (data) => {
        this.setState({
            textToCopy: data
        }, ()=>this.copyToClipboard())
    }

    render() {
        const {textToCopy} = this.state

        const shareUrl = window.location.href
        const whatsappText = `Hey, have you seen Classplus Teachers' Biographies yet?

In this series, Classplus has captured the untold story of select teachers of India and the struggles these teachers faced in their mission to teach millions of students.
        
Watch the first episode of the series now! ${shareUrl}`

        const whatsappShareUrl = encodeURI(whatsappText)
        return (
            <div className="ShareModal">
                <div className="ShareModal__Container">
                    <div className="ShareModal__Container__Top">
                        <div className="ShareModal__Container__Top--Heading">Share</div>
                        <div className="ShareModal__Container__Top--Close" onClick={()=>this.props.toggleShare()}><img src={close} alt=""/> </div>
                    </div>
                    <div className="ShareModal__Container__Body">
                        <div className="ShareModal__Container__Body__Item" onClick={()=> window.open(`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`)}>
                            <div className="ShareModal__Container__Body__Item--Icon">
                                <img src={facebook} alt="" />
                            </div>
                            <div className="ShareModal__Container__Body__Item--Label">Facebook</div>
                        </div>
                        <div className="ShareModal__Container__Body__Item" onClick={()=>{window.open(`https://twitter.com/intent/tweet?text=${shareUrl}`)}}>
                            <div className="ShareModal__Container__Body__Item--Icon">
                                <img src={twitter} alt="" />
                            </div>
                            <div className="ShareModal__Container__Body__Item--Label">Twitter</div>
                        </div>
                        <div className="ShareModal__Container__Body__Item" onClick={()=> window.open(` https://wa.me/?text=${whatsappShareUrl}`)}>
                            <div className="ShareModal__Container__Body__Item--Icon">
                                <img src={whaatsapp} alt="" />
                            </div>
                            <div className="ShareModal__Container__Body__Item--Label">WhatsApp</div>
                        </div>
                        {/* <div className="ShareModal__Container__Body__Item">
                            <div className="ShareModal__Container__Body__Item--Icon">
                                <img src={copy} alt="" />
                            </div>
                            <div className="ShareModal__Container__Body__Item--Label">Copy Link</div>
                        </div> */}

                    </div>
                    <div className="ShareModal__Container__Body">
                        <div className="ShareModal__Container__Body__Item" onClick={()=>this.setCopyText(`${shareUrl}`)}>
                            <div className="ShareModal__Container__Body__Item--Copy">
                                Copy Link
                            </div>
                            
                        </div>

                    </div>
                </div>
                <textarea
                style={{
                    position: "fixed", bottom: "-100vh"
                }}
                ref={(textarea) => this.textArea = textarea}
                value={textToCopy}
                />
                <ToastContainer
                    position={window.innerWidth < 700 ?"top-center":"top-right"}
                    autoClose={3000}
                    hideProgressBar={true}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>
        )
    }
}

export default ShareModal
